module.exports = __webpack_public_path__ + "img/popup8.9c483a30.png";